/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  REMOVE_ACCESS: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.klefki.userList.removeAccess',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'REMOVE_ACCESS' },
      },
    },
    REMOVE_ACCESS: {
      invoke: {
        id: 'removeAccess',
        src: 'removeAccess',
        onDone: {
          target: 'REMOVE_ACCESS_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'REMOVE_ACCESS_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    REMOVE_ACCESS_SUCCESS: {
      on: {
        START: { target: 'REMOVE_ACCESS' },
      },
    },
    REMOVE_ACCESS_FAILED: {
      on: {
        START: { target: 'REMOVE_ACCESS' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
